import { render, staticRenderFns } from "./ZztShenchaModal__Style#Drawer.vue?vue&type=template&id=1a67b536&scoped=true&"
import script from "./ZztShenchaModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./ZztShenchaModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./ZztShenchaModal__Style#Drawer.vue?vue&type=style&index=0&id=1a67b536&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a67b536",
  null
  
)

export default component.exports